module.exports = __webpack_public_path__ + "assets/media/s10.02fa7e9f.mp3";